exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tis-footSmall {\r\n\tpadding: 2px 0px;\r\n}\r\n\r\n.tis-footFondo {\r\n\twidth: 100%;\r\n\theight: 37px;\r\n}\r\n\r\n.tis-footNav {\r\n\tpadding: 0px;\r\n    -webkit-box-shadow: 0px -2px 6px -1px rgba(0,0,0,0.4);\r\n    box-shadow: 0px -2px 6px -1px rgba(0,0,0,0.4);\r\n    background-color: #234460;\r\n}\r\n\r\n.tis-footText {\r\n    padding-top: .3rem;\r\n    padding-bottom: .3rem;\r\n    font-size: 12px;\r\n}\r\n\r\n.tis-footImg {\r\n    margin-bottom: 0.24rem;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/carlos/wks/web/vacios_web/src/app/foot/tis.foot.css
// module id = ../../../../../src/app/foot/tis.foot.css
// module chunks = main